angular.module('impactx.demandbundle').controller('DemandBundleAddDialogCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'TranslationService',
    'themeFactory',
    'noControlPreSet',
    'noBasketPreSet',
    'noMaterialGroupMappingPreSet',
    'hasItemComments',
    'hasHeaderComments',
    'hasOGDInfo',
    'hasSPOInfo',
    DemandBundleAddDialogCtrl]);

function DemandBundleAddDialogCtrl($scope, dataGen, $mdDialog, TranslationService, themeFactory, noControlPreSet, noBasketPreSet,
                                   noMaterialGroupMappingPreSet, hasItemComments, hasHeaderComments, hasOGDInfo, hasSPOInfo) {
    //don't use this with noControlPreSet and noBasketPreSet both set.
    var ctrl = this;
    dataGen.getData($scope, {withBaskets: noBasketPreSet}, "/demandbundle/adddialogdata");
    $scope.abortLabel = TranslationService.get('abort');
    $scope.saveLabel = TranslationService.get('save');
    $scope.requiredLabel = TranslationService.get('required');
    $scope.noSelectedItemMessage = TranslationService.get('noSelectedItemMessage');
    ctrl.headerComments = {value: hasHeaderComments};
    ctrl.itemComments = {value: hasItemComments};
    ctrl.control = {value: !noControlPreSet};
    ctrl.materialGroupMapping = {value: !noMaterialGroupMappingPreSet};
    ctrl.ogdInfoHandling = {value: 0};
    ctrl.spoInfoHandling = {value: 0};
    $scope.hasItemComments = hasItemComments;
    $scope.hasHeaderComments = hasHeaderComments;
    $scope.hasOGDInfo = hasOGDInfo;
    $scope.hasSPOInfo = hasSPOInfo;

    $scope.theme = themeFactory.getTheme();
    $scope.wizardIndex = 0;

    if(noControlPreSet) {
        ctrl.withControl = false;
        $scope.wizardIndex = 1;
    }
    if(noControlPreSet && !hasItemComments && !hasHeaderComments) {
        ctrl.withControl = false;
        $scope.wizardIndex = 2;
    }
    if(noControlPreSet && !hasItemComments && !hasHeaderComments && noMaterialGroupMappingPreSet && hasOGDInfo) {
        ctrl.withControl = false;
        $scope.wizardIndex = 3;
    }
    if(noControlPreSet && !hasItemComments && !hasHeaderComments && noMaterialGroupMappingPreSet && !hasOGDInfo && hasSPOInfo) {
        ctrl.withControl = false;
        $scope.wizardIndex = 4;
    }
    if(noControlPreSet && !hasItemComments && !hasHeaderComments && noMaterialGroupMappingPreSet && !hasOGDInfo && !hasSPOInfo) {
        ctrl.withMaterialGroupMapping = false;
        $scope.wizardIndex = 5;
    }

    this.cancel = function() {
        $mdDialog.cancel();
    };

    this.forward = function() {
        $scope.wizardIndex++;
        this.forwardUntilDecisionNeeded();
        if ($scope.wizardIndex > 5) {
            ctrl.hideDialog();
        }
    };

    this.forwardUntilDecisionNeeded = function () {
        if ($scope.wizardIndex === 0) {
            if (noControlPreSet) {
                $scope.wizardIndex++;
                ctrl.forwardUntilDecisionNeeded();
            }
        }
        if ($scope.wizardIndex === 1) {
            if (!hasItemComments && !hasHeaderComments) {
                $scope.wizardIndex++;
                ctrl.forwardUntilDecisionNeeded();
            }
        }
        if ($scope.wizardIndex === 2) {
            if (noMaterialGroupMappingPreSet) {
                $scope.wizardIndex++;
                ctrl.forwardUntilDecisionNeeded();
            }
        }
        if ($scope.wizardIndex === 3) {
            if (!hasOGDInfo) {
                $scope.wizardIndex++;
                ctrl.forwardUntilDecisionNeeded();
            }
        }
        if ($scope.wizardIndex === 4) {
            if (!hasSPOInfo) {
                $scope.wizardIndex++;
                ctrl.forwardUntilDecisionNeeded();
            }
        }
        if ($scope.wizardIndex === 5) {
            if (!noBasketPreSet) {
                $scope.wizardIndex++;
                ctrl.forwardUntilDecisionNeeded();
            }
        }
    };

    this.hideDialog = function () {
        $mdDialog.hide({
            withControl: ctrl.control.value,
            withMaterialGroupMapping: ctrl.materialGroupMapping.value,
            copyHeaderComments: ctrl.headerComments.value,
            copyItemComments: ctrl.itemComments.value,
            bkhId: noBasketPreSet ? $scope.data.basketPopup.selected.id : 0,
            ogdInfoHandling: ctrl.ogdInfoHandling.value,
            spoInfoHandling: ctrl.spoInfoHandling.value
        });
    };
}